module.exports = __webpack_public_path__ + "static/media/plus-icon.1462b171.svg";